export default {
  lightserver: {
    title: 'Light Server',
    pageHeader: 'Light Server',
    // 实例
    instance: {
      name: 'Instances',
      storageName: 'Storage',
      snapshotName: 'Snapshots',
      purchaseBtn: 'Purchase Light Server',
      // 搜索栏
      searchBar: {
        formPlaceholder: 'Search For ID /IP / Names',
        searchBtn: 'Search'
      },
      // 地区筛选
      locationFilter: {
        header: 'Location',
        placeholder: 'Select a region to filter'
      },
      // 实例列表
      dataList: {
        purchaseGuide: {
          tip: 'No data found, you can',
          purchaseLink: ' create an instance'
        },
        columns: {
          name: 'Instance Name / IP',
          config: 'Config',
          traffic: 'Remaining / Total Traffic',
          image: 'Image',
          hardDisk: 'Hard Disk',
          zone: 'Zone',
          validityPeriod: 'Validity Period',
          status: {
            header: 'Status',
            creating: 'Creating',
            installing: 'Installing',
            starting: 'Starting',
            running: 'Running',
            stopping: 'Stopping',
            stopped: 'Stopped',
            expiresSoon: 'Expiring soon',
            unknown: 'Unknown Status',
            failed: 'Installation Failed',
            disabled: 'Disabled'
          },
          actions: 'Actions'
        },
        actions: {
          connect: 'Connect',
          manage: 'Manage',
          renew: 'Renew',
          createSnapShot: 'Create Snapshot',
          start: 'Start',
          stop: 'Stop',
          restart: 'Restart',
          upgrade: 'Upgrade',
          reinstall: 'Reinstall',
          resetPassword: 'Reset Password',
          rename: 'Rename',
          trafficBilling: 'Traffic Billing Policy Settings',
        }
      },
      // 续费弹框
      renewDialog: {
        copySuccess: 'Copied to clipboard.',
        copyFail: 'Copy fail.',
        header: 'Renew Light Server',
        // instanceCounter: '<span style="color:#37f;">#num#</span> instance#s# selected',
        summary: {
          name: 'Summary',
          cpu: 'vCore#s# CPU',
          bandwidth: 'M Bandwidth',
          memory: 'GB RAM',
          publicIp: 'Public IP Address(es)',
          publicIpMark: '(Public)',
          statusRunning: 'Running',
          statusStopped: 'Stopped'
        },
        duration: {
          header: 'Duration:',
          month: 'Month',
          months: 'Months',
          year: 'Year',
          years: 'Years'
        },
        password: {
          header: 'Password',
          placeholder: 'Please enter the login password'
        },
        charges: {
          name: 'Price:',
          discountDesc: '$#s# off'
        },
        buttons: {
          cancel: 'Cancel',
          renew: 'Renew'
        }
      },
      // 关机弹框
      shutdownDialog: {
        header: 'Stop',
        selectedInstance: {
          countDesc: '<span style="color:#37f;">#num#</span> <span>instance</span> selected',
          statusStoppable: 'Stoppable',
          statusUnstoppable: 'Unstoppable'
        },
        tips: {
          tip1: 'Sure to shut down the server? During the shutdown, the host will not be able to provide service normally, please be prepared to avoid any impact.',
          tip2: 'Forced shutdown may result in data loss or file system corruption. Use it only when the server cannot be shut down normally.',
        },
        shutdownConfirmation: 'Confirm to use forced shutdown.',
        buttons: {
          cancel: 'Cancel',
          stop: 'Stop'
        }
      },
      // 开机弹框
      bootDialog: {
        header: 'Start',
        selectedInstance: {
          countDesc: '<span style="color:#37f;">#num#</span> <span>instance</span> selected',
          statusStartable: 'Startable',
          statusUnstartable: 'Unstartable'
        },
        buttons: {
          cancel: 'Cancel',
          start: 'Start'
        }
      },
      // 重启弹框
      rebootDialog: {
        header: 'Restart',
        selectedInstance: {
          countDesc: '<span style="color:#37f;">#num#</span> <span>instance</span> selected',
          statusRestartable: 'Restartable',
          statusNonrestartable: 'Non-Restartable'
        },
        tips: {
          tip1: 'Sure to restart the server? During the restart, the host will not be able to provide service normally, please be prepared to avoid any impact.',
          tip2: 'Forced shutdown may result in data loss or file system corruption. Use it only when the server cannot be shut down normally.'
        },
        restartConfirmation: 'Confirm to force restart.',
        buttons: {
          cancel: 'Cancel',
          restart: 'Restart'
        }
      },
      // 重命名弹框
      renameDialog: {
        header: 'Rename',
        newName: {
          header: 'New Name',
          placeholder: 'Please enter a new Name here'
        },
        description: {
          header: 'Description'
        },
        buttons: {
          cancel: 'Cancel',
          rename: 'Rename'
        }
      },
      // 重置密码弹框
      resetPwdDialog: {
        header: 'Reset Password',
        n: {
          header: 'New Password',
          placeholder: 'Please enter a new password here',
          tip: '8~16 charaters. At least consists of 3 kinds of upper/lower-case letters, numbers, and special charaters (!@#^&*()_+-=).'
        },
        c: {
          header: 'Confirm Password',
          placeholder: 'Please enter a new password here'
        },
        tip: 'Caution: The server will restart after password changes, which may cause data loss or file system damage.',
        buttons: {
          cancel: 'Cancel',
          done: 'Done'
        }
      },
      // 创建快照弹框
      createSnapshotDialog: {
        header: 'Create Snapshot',
        relatedInstance: 'Related Instance :',
        search: 'Search',
        searchPlaceholder: 'Please select a instance',
        noteList: {
          tag: 'Note:',
          first: 'The free snapshot quota for each region is the number of created instances (including stopped and disabled instances due to overpayment) multiplied by 2 and cannot exceed 10.',
          second: 'Snapshots usually can be created within 5 minutes.You do not need to shut down the instance during the creation.'
        },
        columnList: {
          name: 'Instance Name/ID :',
          package: 'Instance Package :',
          diskCapacity: 'Disk Capacity :',
          snapshotName: 'Snapshot Name :',
          snapshotPlaceholder: 'Please enter a new snapshot name here',
          snapshotTag: '2~60 Characters'
        },
        buttons: {
          cancel: 'Cancel',
          done: 'Done'
        },
        error: {
          err1: 'Please enter a name',
          err2: 'The name does not meet the word count requirements!'
        }
      },
      // 升级弹框
      upgradeDialog: {
        header: 'Upgrade',
        steps: {
          one: 'Select Package to Upgrade',
          two: 'Backend Server'
        },
        notesForStepOne: {
          header: 'Note:',
          one: 'Light Server instances only support package upgrade (higher CPU, memory,SSD system disk capacity, bandwidth/peak bandwidth and monthly traffic). Note that the package cannot be downgraded.',
          two: 'After the upgrade. the current IP address, firewall rules, password/key, and snapshot of the instance are not affected. The instance expiration time remains unchanged.',
          three: 'You cannot change the available zone in the upgrade.'
        },
        counter: '1 instance selected',
        configureHeader: {
          instance: 'Instance ID/Name',
          configuration: 'Configuration',
          zone: 'Zone',
          expireTime: 'Expiration Time'
        },
        packagePicker: {
          header: 'select a package',
          attributes: {
            cpu: 'CPU Core',
            disk: 'System Disk',
            memory: 'Memory',
            bandwidth: 'Bandwidth',
            traffic: 'Data Traffic'
          },
          units: {
            month: 'Mon',
            core: 'Core#s#',
          }
        },
        charges: {
          header: 'Charges',
          discountDesc: '$#s# off'
        },
        buttons: {
          cancel: 'Cancel',
          next: 'Next',
          previous: 'Previous',
          pay: 'Pay'
        },
        notesForStepTwo: {
          header: 'Note:',
          one: 'If the system disk needs to be expanded during the package upgrade, you do not need to manually expand the partition and file system after the upgrade is successful, and the current data will not be affected.',
          two: 'The current operation requires the instance to be powered off: To avoid data loss, the instance will shut down and interrupt your business, please confirm carefully. Forced shutdown may result in data loss or file system corruption, but you can also actively shut down before proceeding. Forced shutdown may require you to wait for a long time, please be patient.',
        },
        agreement: '<a href="javascript:;">Instance Upgrade Package Fee Description</a>'
      },
      //计费策略设置
      chargeSetting: {
        header: 'Traffic Billing Policy Settings',
        confirm: {
          note1: 'The operation will be performed on the selected',
          note2: '1 instance',
          note3: '. Are you sure you want to proceed?',
        },
        instance: {
          ip: 'IP Address',
          name: 'Tag',
          zone: 'Zone',
          os: 'Operating System',
          time: 'Validity Period',
        },
        radio: {
          'subscriptionOnly': 'Stop instance once the traffic package is used up',
          'payAsYouGo': 'Pay as you go once the traffic package is used up',
        },
        notice: {
          'text': 'Note: If the later is selected, your instance will be billed by the usage of excess traffic hourly after the traffic package is used up.',
          'href': 'Excess Traffic Pricing',
          'dot': '.',
        }
      },
      // 监控数据放大图表弹框
      monitorZoomDialog: {
        buttons: {
          realTime: 'Real Time',
          oneDay: 'Last 24 Hours',
          sevenDays: 'Last 7 Days',
          thirtyDays: 'Last 30 Days',
          refresh: 'Refresh'
        }
      },
      // 导出数据弹框
      exportDialog: {
        header: 'Export Data',
        granularity: {
          header: 'Time granularity:',
          fifteenSeconds: '15 Seconds',
          oneMinute: '1 Minute',
          fiveMinutes: '5 Minutes'
        },
        timeRange: 'Time Range:',
        exportItems: 'Export Items:',
        buttons: {cancel: 'Cancel', confirm: 'Confirm'}
      },
      // 页面
      pages: {
        // 详情页
        detail: {
          tabs: {
            overview: 'Overview',
            application: 'Application',
            hardDisk: 'HardDisk',
            firewall: 'Firewall',
            snapshot: 'Snapshot',
            monitoring: 'Monitoring'
          },
          tabOverview: {
            actions: {
              renew: 'Renew',
              upgrade: 'Upgrade'
            },
            resourceInfo: {
              header: 'Resource Usage',
              trafficPackage: 'Traffic Package',
              systemDisk: 'System Disk',
              uninstallMessage: 'You must install the monitoring agent before you can view the data of some monitoring charts. We recommend that you',
              uninstallUrlTitle: 'How to install?',
              loading: 'Loading'
            },
            monitoringInfo: {
              header: 'Performance Monitoring',
              cpuUsage: 'CPU Utilization (%)',
              memoryUsage: 'Memory Usage (%)'
            },
            loginInfo: {
              header: 'Remote Login',
              vncLogin: 'VNC Login',
              vncMessage: 'Remotely log in to the instance through a web browser, which is often used for troubleshooting.',
              vncButton: 'Login',
              sshLogin: 'SSH Remote Login',
              sshMessage: 'You can use local SSH client software to remotely log in to the instance.',
              sshTag: 'ssh root@'
            },
            instanceInfo: {
              header: 'Instance Information',
              resetPassword: 'Reset Password',
              restart: 'Restart',
              start: 'Start',
              stop: 'Stop',
              columnList: {
                name: 'Name/ID :',
                ip: 'IP Address :',
                specification: 'Specification :',
                systemDisk: 'System Disk :',
                zone: 'Zone :',
                trafficPackage: 'Traffic Package :',
                month: 'month',
                status: 'Status :'
              }
            },
            systemInfo: {
              header: 'System Information',
              image: 'Image Name :',
              osType: 'OS Type :',
              firewall: 'Firewall :',
              firewallDefault: 'Manage Rules',
              imageType: 'Image Type :',
              systemImage: 'System Image',
              applicationImage: 'Application Image',
              operatingSystem: 'Operating System :',
              reinstall: 'Reinstall'
            },
            billingInfo: {
              header: 'Billing Information',
              upgrade: 'Upgrade',
              renew: 'Renew',
              billingType: 'Billing Type :',
              billingDefault: 'Billing monthly',
              creationTime: 'Creation Time :',
              expirationTime: 'Expiration Time :'
            }
          },
          tabApplication: {
            addressInfo: {
              header: 'Application Software Installation Address'
            },
            applicationInfo: {
              header: 'Application Information',
              appName: 'Application Name :',
              status: 'Status :',
              resetPassword: 'Reset Password',
              restart: 'Restart',
              start: 'Start',
              stop: 'Stop'
            },
            inAppInfo: {
              header: 'In-App Software Information',
              appLoginMessage: 'Please copy the following command and login to the server, paste to execute',
              login: 'Login',
              copySuccess: 'Success',
              copyError: 'Fail'
            }
          },
          tabHardDisk: {
            searchBar: {
              placeholder: 'Search for Name or Instance ID',
              btn: 'Search'
            },
            columns: {
              name: 'ID / Name',
              status: 'Status',
              statusList: {
                deleted: 'Deleted',
                unknown: 'Unknown',
                creating: 'Creating',
                unmounted: 'Unmounted',
                mounting: 'Mounting',
                inUse: 'In Use',
                unmounting: 'Unmounting',
                paused: 'Paused',
                expired: 'Expired'
              },
              zone: 'Zone',
              diskType: 'Disk Type',
              diskCategory: 'Disk Category',
              capacity: 'Used / Total Capacity',
              period: 'Creation / Expiration Time',
              actions: 'Actions',
              createSnapShot: 'Create Snapshot'
            }
          },
          tabSnapshot: {
            searchBar: {
              placeholder: 'Search for Name or Instance ID',
              btn: 'Search'
            },
            columns: {
              name: 'Snapshot Name',
              status: 'Status',
              statusList: {
                deleted: 'Deleted',
                unknown: 'Unknown',
                creating: 'Creating',
                unmounted: 'Unmounted',
                mounting: 'Mounting',
                inUse: 'In Use',
                unmounting: 'Unmounting',
                paused: 'Paused',
                expired: 'Expired'
              },
              instanceName: 'Instance ID / Name',
              remark: 'Remark',
              creationTime: 'Creation Time',
              rollbackResult: 'Rollback Result',
              success: 'Success',
              error: 'Error',
              actions: 'Actions',
              rollback: 'Rollback',
              delete: 'Delete'
            }
          }
        },
        loginPage: {header: 'Connect'},
        // 重装系统页
        reinstall: {
          header: 'Reinstall: #s#',
          configure: {
            core: 'Core#s#',
            memory: 'RAM',
            ipAttribute: '(Public)'
          },
          imageType: {
            header: 'Image Type:',
            appMirror: 'Application Image',
            systemMirror: 'System Image',
          },
          selectImage: {
            header: 'Select Image:',
            tip: 'Select a image'
          },
          loginPassword: {
            header: 'Login Password:',
            placeholder: 'Please enter a new password here'
          },
          notes: {
            header: 'Reinstalling the system will delete the snapshots of the system disk and cannot be restored, please proceed with caution.',
            one: 'The password must be between 8 and 16 characters, including uppercase letters, lowercase letters, numbers and special characters such as !?@#^&*()_+\\-=.',
            two: 'The instance will be forced to shut down',
            three: 'The current system disk of the instance will be cleared and reset to the selected image'
          },
          agreement: 'Confirm that I have read and understood the above and the backup is done.',
          buttons: {
            cancel: 'Cancel',
            confirm: 'Confirm'
          },
          errorTip: {
            password: 'Please input the login password',
            agreement: 'Please agree and confirm that you are aware of the risk statement of reinstalling the system'
          }
        },
        // 监控页
        monitor: {
          buttons: {export: 'Export Data', refresh: 'Refresh', exportImage: 'Export Image'},
          timeRange: {realTime: 'Real Time', oneDay: 'Last 24 Hours', sevenDays: 'Last 7 Days', thirtyDays: 'Last 30 Days'},
          note: {header: 'Note', content: 'Max, Min and Avg are the maximum, minimum and average values of all points in the current line chart respectively'},
          monitorDataError: 'Failed to get monitoring data',
          metrics: {
            statistics: {max: 'Max', min: 'Min', avg: 'Avg'},
            units: {packetPerSecond: '/sec'},
            cpu: {
              header: 'CPU Monitoring',
              usage: {
                title: 'CPU Utilization',
                desc: 'The CPU utilization is collected and reported through the internal monitoring component of the server, and the data is more accurate'
              },
              average: {title: 'CPU Utilization Average'}
            },
            memory: {
              header: 'Memory Monitoring',
              usage: {
                title: 'Memory Usage',
                desc: 'The amount of memory used, excluding the system cache and the memory occupied by the cache area, depends on the installation and collection of monitoring components'
              },
              usageRatio: {
                title: 'Memory Usage Ratio',
                desc: 'The ratio of the amount of memory actually used by the user to the total amount of memory, excluding the memory occupied by buffers and system caches'
              }
            },
            network: {
              header: 'Public Network Bandwidth Monitoring',
              extranetBandwidth: {
                title: 'Public Bandwidth Out',
                desc: 'The average outgoing traffic per second of the external network, the minimum granularity data is calculated as 15 seconds total traffic / 15 seconds.'
              },
              intranetBandwidth: {
                title: 'Public Bandwidth In',
                desc: 'Average Public Inbound Traffic Per Second'
              },
              outboundPacketVolume: {
                title: 'Public Outbound Packets',
                desc: 'Average Public Outbound Packets Per Second'
              },
              inboundPacketVolume: {
                title: 'Public Inbound Packets',
                desc: 'Average Public Inbound Packets Per Second'
              },
              outboundTraffic: {
                title: 'Public Network Outbound Traffic',
                desc: 'Average Public Outbound Traffic'
              }
            },
            disk: {
              header: 'Hard Disk Usage And Monitoring',
              diskReadTraffic: {
                title: 'Hard Disk Read Traffic',
                desc: 'Average amount of data read from disk to memory per second'
              },
              diskWriteTraffic: {
                title: 'Hard Disk Write Traffic',
                desc: 'Average amount of data written from memory to disk per second'
              },
              diskReadIops: {
                title: 'Hard Disk Read IOPS',
                desc: 'The average number of reads per second on the hard disk'
              },
              diskWriteIops: {
                title: 'Hard Disk Write IOPS',
                desc: 'The average number of writes per second on the hard disk'
              }
            }
          },
        }
      }
    },
    // 快照
    snapshot: {
      name: 'Snapshots',
      list: {
        searchBar: {placeholder: 'Snapshot Name / ID or Light Server ID or Storage ID', btn: 'Search'},
        headerColumns: {
          name: 'Snapshot Name / ID',
          disk: 'Disk',
          creationTime: 'Creation Time',
          associatedServer: 'Related server',
          status: {header: 'Status'},
          action: {header: 'Actions', delete: 'Delete', rollback: 'Roll Back Disk', editTag: 'Edit Tag'}
        }
      },
      // 删除弹框
      deleteDialog: {
        header: 'Delete Snapshot',
        tip1: 'Sure to delete <span style="color:#37f;">#sn#</span> ?',
        tip2: 'After deletion, it cannot be restored. Please be cautious.',
        buttons: {cancel: 'Cancel', delete: 'Delete'}
      },
      // 回滚弹框
      rollbackDialog: {
        header: 'Roll Back Disk',
        pleaseSelect: 'Please select',
        notes: {
          one: 'The data on the system disk will be cleared. Please proceed with caution!',
          two: 'A disk can be rolled back only if the instance has been stopped and the current disk has no snapshot being created.',
          three: 'In order to ensure that the snapshot rollback is successful, please do not alter the instance status during the rollback, such as shutting down, restarting, or reinstalling the instance. Otherwise, the rollback will fail. Please wait patiently.',
        },
        options: {
          one: {
            one: 'Now shut down and roll back',
            two: 'Automatic shutdown (you must shut down first for immediate rollback)',
            three: 'Confirm to shut down immediately'
          },
          two: {
            one: 'Apply for rollback',
            two: 'Rollback takes time. After you apply for rollback, an email will be sent to you to remind you of the rollback. Then the system will automatically shut down and rollback.'
          },
          agreement: 'Restart the instance immediately after rollback',
          buttons: {cancel: 'Cancel', rollback: 'Roll back'}
        }
      },
      // 修改名称弹框
      editTagDialog: {
        header: 'Rename Snapshot',
        id: 'Snapshot ID:',
        oldName: 'Name:',
        newName: 'New Name:',
        placeholder: '',
        tip: 'Length is limited to 6-24 characters Start with letters and can contain numbers, "." and "_".',
        buttons: {cancel: 'Cancel', save: 'Save'}
      }
    },
    // 防火墙
    firewall: {
      name: 'Firewall',
      // 添加规则弹框
      addRuleDialog: {
        header: 'Add a rule',
        note: {header: 'Note:', detail: 'The rule controls the inbound traffic of the Light Server instance'},
        applicationType: 'Application type',
        sourceIp: {
          header: 'Source IP to be used', placeholder: 'Source IP to be used',
          tooltip: 'All IP (0.0.0.0)\nSingle IP (10. x.x.y)\nIP segment (x.y.z.0 / 24)\nMultiple IPs (10. x.y.z, 11. x.y.z, 12. x.y.z)',
        },
        portRange: {
          header: 'Port range', placeholder: 'such as 0.0.0.0, 0.0.0.0/24',
          tooltip: 'Port format:\nSingle port: 22\nPort range: 10 / 20\nAll ports: -1 / -1'
        },
        policy: {header: 'Policy', allow: 'Allow', reject: 'Reject'},
        remark: {header: 'Remark', placeholder: 'Remark'},
        buttons: {cancel: 'Cancel', done: 'Done'}
      },
      // 列表
      list: {
        addBtn: 'Add Rule',
        headerColumns: {
          applicationType: 'Application Type',
          sourceIp: 'Source IP to be used',
          portRange: 'Port range',
          policy: 'Policy',
          remark: 'Remark',
          actions: {
            header: 'Actions',
            delete: 'Delete'
          }
        },
        policyTypes: {
          allow: 'Allow',
          reject: 'Reject'
        }
      },
      // 删除规则弹框
      deleteRuleDialog: {
        header: 'Delete Rule',
        ask: 'Are you sure to delete the rule #s# ?',
        buttons: {cancel: 'Cancel', confirm: 'Confirm'}
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/lightserver.js